import React from "react";

import { StyledIcon } from "./style";

export const BreadcrumbChevron: React.FC = () => (
  <StyledIcon aria-hidden="true">V</StyledIcon>
);

export default BreadcrumbChevron;
